import React from 'react';
import { Link } from 'react-router-dom';
import Banner from '../Common/Banner';
import Slider from 'react-slick';
import DocumentMeta from 'react-document-meta';

class About extends React.Component {
	render() {

		var settings = {
			dots: true,
			autoplay: true,
			infinite: true,
			speed: 500,
			slidesToShow: 2,
			slidesToScroll: 1,

			responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};

		const whyUsItems = [
			{
				icon: 'pe-7s-star',
				title: 'Den Bedste I Klassen',
				desc: 'Hos Alaska Cykler tilbyder vi et bredt sortiment af kvalitetscykler og cykeltilbehør til rimelige priser.'
			},
			{
				icon: 'pe-7s-tools',
				title: 'Cykelreparation',
				desc: 'Vi reparerer din cykel med en kærlig hånd og genopfrisker den, så den kan klare det danske vejr.'
			},
			{
				icon: 'pe-7s-bicycle',
				title: 'Cykeludlejning',
				desc: 'Du har også mulighed for at låne en cykel, hvis din cykel er på værksted, eller du blot har brug for en ekstra cykel i et par dage.'
			},
			{
				icon: 'pe-7s-lock',
				title: 'Nøglefremstilling',
				desc: 'Vi tilbyder professionel nøgleservice i butikken og gør din nye nøgle klar på ingen tid.'
			},
			{
				icon: 'pe-7s-smile',
				title: 'Kvalitetssupport',
				desc: 'Vi sætter en ære i at hjælpe dig med personlig rådgivning, så din hverdag på to hjul bliver nem og bekvem.'
			},
			{
				icon: 'pe-7s-shield',
				title: '10 Års Stelgaranti',
				desc: 'Vi tilbyder vores kunder 10 års garanti på stellet og et års gratis eftersyn samt 2 års reklamationsret ved køb.'
			}
		];

		const testimonials = [
			{
				title: 'Kvalitetscykler til fornuftige priser',
				text: 'Jeg har købt Amore damecykel hos Alaska cykler i Oktober måned. Cyklen passer lige til mine ønsker og behov. Jeg er meget tilfreds med den. Tak Alaska cykler, for at tilbyde en super god service.',
				author: 'Ms. Denise',
				img: '../images/faces/1.jpg'
			},
			{
				title: 'Hurtig og serviceminded',
				text: 'Jeg fik repareret min cykel hos Alaska Cykler i sidste måned. Min cykel trængte til et eftersyn, og jeg valgte Alaska Cykler. Jeg var positivt overrasket over at få min cykel tilbage til tiden, og jeg fik endda lidt ekstra service helt gratis ved siden af. Hurtig og rar betjening.',
				author: 'Ms. Natasha',
				img: '../images/faces/2.jpg'
			},
			{
				title: 'God oplevelse',
				text: 'Købte en Van De Falk Classic cykel for to måneder siden. Kvaliteten er i top til en overkommelig pris. Betjeningen er behagelig, ærlig og professionel.',
				author: 'Ms. Moly',
				img: '../images/faces/3.jpg'
			},
			{
				title: 'Gode tilbud på cykler',
				text: 'Priser og service er helt i top, med smilende betjening og god rådgivning. De har altid gode tilbud på kvalitetscykler, så de kan varmt anbefales.',
				author: 'Ms. Sara',
				img: '../images/faces/4.jpg'
			}
		];

		const meta = {
            title:          'Vi tilbyder overkommelige og pålidelige cykelreparationer og salg',
            description:    'Vi skræddersyer cykler efter din personlige behov og smag. Vores medarbejder har 15 års erfaring fra både Tyskland og Sverige, som har fokus på kvalitet, design og funktion af alle vores produkter.',
            canonical:      window.location.href,
            meta: {
                charset:    'utf-8',
                name: {
                    keywords: 'cykler københavn, cykel reparation københavn, alaska cykler, nøgle maker københavn'
                }
            }
        };

		return (
			<div className="main-content" id="about-page">
                
                <DocumentMeta {...meta} />

				<Banner 
					pageName='Om Os' 
					pageID='about' 
					pageDesc='Vi tilbyder overkommelige og pålidelige cykelreparationer og salg' 
					url='http://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,h_600,q_60,w_1000/v1509207869/backgrounds/slider.jpg' />

				<div className="scroll-stop"></div>

				{/* Story & Mission Section */}
				<div className="container about-story-section">
					<div className="row about-story-row">
						<div className="col-md-5 col-sm-12">
							<div className="about-image-card">
								<img src="https://res.cloudinary.com/dttrnjoc5/image/upload/v1509207870/backgrounds/about-1.png" alt="Om Alaska Cykler" />
								<div className="experience-badge">
									<span className="years">15+</span>
									<span className="label-text">Års erfaring fra Tyskland, Sverige &amp; Danmark</span>
								</div>
							</div>
						</div>

						<div className="col-md-7 col-sm-12">
							<div className="about-content-card">
								<span className="section-overline">OM ALASKA CYKLER</span>
								<h2>Vi åbner dørene for en ny verden af cykelkultur</h2>
								<p className="lead-text">
									Danmark er et af verdens førende cykellande, og cyklen er en uundværlig del af hverdagen. Hos Alaska Cykler kombinerer vi klassisk håndværk med moderne design og personlig service.
								</p>

								<div className="story-blocks">
									<div className="story-block">
										<h4><span className="pe-7s-like" /> Vi elsker cykler</h4>
										<p>Vi tilpasser cykler efter dine personlige behov og ønsker. Vores medarbejdere har over 15 års erfaring fra både Tyskland og Sverige med fokus på kvalitet, design og funktionalitet i alle produkter.</p>
									</div>

									<div className="story-block">
										<h4><span className="pe-7s-medal" /> Vores viden – din styrke</h4>
										<p>Vi rådgiver dig gerne, så du finder netop den cykel, der opfylder dine drømme. Vi udvælger vores sortiment med omhu og kvalitetstester produkterne, så du kan føle dig helt tryg ved dit køb – uanset om du søger en splinterny cykel, tilbehør eller professionel reparation på vores moderne værksted.</p>
									</div>
								</div>

								<div className="about-cta-group">
									<Link to="/cycles" className="btn btn-primary">Se Vores Cykler</Link>
									<Link to="/contact" className="btn btn-default">Kontakt Os</Link>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Why Choose Us - 6 Card Grid (2x3) */}
				<div className="bg-color-default">
					<div className="container why-us-box-container">
						<header className="header header-main text-left row">
	                        <h2 className="col-md-12 text-left">
	                        	Hvorfor vælge os
	                        	<p>Der er mange gode grunde til at vælge os – hos os finder du flere services samlet under ét tag.</p>
	                        </h2>
	                    </header>
						<div className="row why-us-grid">
							{whyUsItems.map((item, idx) => (
								<div className="col-xs-12 col-sm-6 col-md-4 why-us-col" key={idx}>
									<div className="why-us-box-wrapper">
										<div className="icon">
											<i className={item.icon}></i>
										</div>
										<div className="details">
											<h4>{item.title}</h4>
											<p>{item.desc}</p>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>

				{/* Customer Testimonials */}
				<div className="container">
					<header className="header header-main text-left row">
                        <h2 className="col-md-12 text-left">
                        	Brugeranmeldelser
                        	<p>Hvad vores kunder siger om os</p>
                        </h2>
                    </header> 

					<div className="row">
						<div className="col-sm-12" style={{overflow: 'hidden'}}>
							<div className="testimonial-container">
								<Slider {...settings}>
									{testimonials.map((item, index) => (
										<div className="testimonial-wrapper" key={index}>
											<div className="inner">
												<div className="review-stars">
													<span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
												</div>
												<h3 className="review-title">{item.title}</h3>
												<p className="review-text">“{item.text}”</p>
												<div className="review-author">
													<div className="image">
														<img src={item.img} alt={item.author} />
													</div>
													<div className="author-meta">
														<h4>{item.author}</h4>
													</div>
												</div>
											</div>
										</div>
									))}
								</Slider>
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default About;




// WEBPACK FOOTER //
// ./src/Pages/About.js